/**
 * @generated SignedSource<<c8b443509572c9492e4ff9bf6e4c9063>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type shareHeaderFeaturesContent$data = {
  readonly " $fragmentSpreads": FragmentRefs<"shareArticle20Content">;
  readonly " $fragmentType": "shareHeaderFeaturesContent";
};
export type shareHeaderFeaturesContent$key = {
  readonly " $data"?: shareHeaderFeaturesContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"shareHeaderFeaturesContent">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "shareHeaderFeaturesContent"
};

(node as any).hash = "bbc24bd154d15c1cd3b0ae41e9e845b9";

export default node;
